/** flash.geom.ColorTransform (double precision; display objects quantize to Fixed8/int16 when assigned). */
export class ColorTransform {
  redMultiplier: number;
  greenMultiplier: number;
  blueMultiplier: number;
  alphaMultiplier: number;
  redOffset: number;
  greenOffset: number;
  blueOffset: number;
  alphaOffset: number;

  constructor(
    rm: number = 1,
    gm: number = 1,
    bm: number = 1,
    am: number = 1,
    ro: number = 0,
    go: number = 0,
    bo: number = 0,
    ao: number = 0,
  ) {
    this.redMultiplier = +rm;
    this.greenMultiplier = +gm;
    this.blueMultiplier = +bm;
    this.alphaMultiplier = +am;
    this.redOffset = +ro;
    this.greenOffset = +go;
    this.blueOffset = +bo;
    this.alphaOffset = +ao;
  }

  get color(): number {
    return ((this.redOffset << 16) | (this.greenOffset << 8) | this.blueOffset) >>> 0;
  }

  /** Sets RGB offsets from `color` and the RGB multipliers to 0 (alpha untouched). */
  set color(c: number) {
    c = c >>> 0;
    this.redMultiplier = 0;
    this.greenMultiplier = 0;
    this.blueMultiplier = 0;
    this.redOffset = (c >> 16) & 0xff;
    this.greenOffset = (c >> 8) & 0xff;
    this.blueOffset = c & 0xff;
  }

  concat(second: ColorTransform): void {
    this.alphaOffset += this.alphaMultiplier * second.alphaOffset;
    this.alphaMultiplier *= second.alphaMultiplier;
    this.redOffset += this.redMultiplier * second.redOffset;
    this.redMultiplier *= second.redMultiplier;
    this.greenOffset += this.greenMultiplier * second.greenOffset;
    this.greenMultiplier *= second.greenMultiplier;
    this.blueOffset += this.blueMultiplier * second.blueOffset;
    this.blueMultiplier *= second.blueMultiplier;
  }

  clone(): ColorTransform {
    return new ColorTransform(
      this.redMultiplier,
      this.greenMultiplier,
      this.blueMultiplier,
      this.alphaMultiplier,
      this.redOffset,
      this.greenOffset,
      this.blueOffset,
      this.alphaOffset,
    );
  }

  toString(): string {
    return (
      `(redMultiplier=${this.redMultiplier}, greenMultiplier=${this.greenMultiplier}, blueMultiplier=${this.blueMultiplier}, ` +
      `alphaMultiplier=${this.alphaMultiplier}, redOffset=${this.redOffset}, greenOffset=${this.greenOffset}, ` +
      `blueOffset=${this.blueOffset}, alphaOffset=${this.alphaOffset})`
    );
  }
}
